import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Stream from 'flarum/utils/Stream';
import Button from 'flarum/common/components/Button';
import Select from 'flarum/common/components/Select';

export default class pdfPrepareModal extends Modal {
  static isDismissibleViaBackdropClick = false;
  static isDismissibleViaCloseButton = true;

  oninit(vnode) {
    super.oninit(vnode);
    this.callback = this.attrs.callback;
    this.companyNameA = Stream("");
    this.companyNameB = Stream("");
    this.yj = Stream("");
    this.zff = Stream("收购方");
  }

  className() {
    return 'Modal--small';
  }

  title() {
    return ["可选参数配置"];
  }

  content() {
    return [
      <div className="Modal-body u2diSubmitModalBody" style="text-align: center;padding: 0px 0px 30px 0px;">
        <div style="gap: 20px;" className="u2diUserSubmitCategoryItems">
          <div style="text-align: right;width: 95px;" className="u2diUserSubmitCategoryItemName">
            甲方公司
          </div>
          <div className="u2diUserSubmitCategoryItemOptions">
            <input style="width:230px" className="FormControl u2diUserSubmitCategoryItemInput" type="input" bidi={this.companyNameA} />
          </div>
        </div>
        <div style="gap: 20px;" className="u2diUserSubmitCategoryItems">
          <div style="text-align: right;width: 95px;" className="u2diUserSubmitCategoryItemName">
            乙方公司
          </div>
          <div className="u2diUserSubmitCategoryItemOptions">
            <input style="width:230px" className="FormControl u2diUserSubmitCategoryItemInput" type="input" bidi={this.companyNameB} />
          </div>
        </div>
        <div style="gap: 20px;" className="u2diUserSubmitCategoryItems">
          <div style="text-align: right;width: 95px;" className="u2diUserSubmitCategoryItemName">
            溢价方式
          </div>
          <div className="u2diUserSubmitCategoryItemOptions">
            <input style="width:180px" className="FormControl u2diUserSubmitCategoryItemInput" type="number" bidi={this.yj} placeholder="留空则为总额比例方式" />　 万/亩
          </div>
        </div>
        <div style="gap: 20px;" className="u2diUserSubmitCategoryItems">
          <div style="text-align: right;width: 95px;" className="u2diUserSubmitCategoryItemName">
            费用支付
          </div>
          <div style="text-align: left;" className="u2diUserSubmitCategoryItemOptions">
            <Select className="u2diDataSelectList" value={this.zff()}
              options={{
                "收购方":"收购方支付",
                "委托方":"委托方支付",
              }}
              onchange={(e) => {
                this.zff(e);
                m.redraw();
              }}
            />
          </div>
        </div>
        <div className="u2diManagementButtonsContainer" style="text-align: center;padding-top: 20px;">
          {Button.component({
              style:"min-width:66px;",
              className: 'Button Button--primary',
              onclick: () => {
                this.submitData()
              }
            },
            app.translator.trans('ziven-u2di.forum.item-generate-jjxy')
          )}
        </div>
      </div>
    ];
  }

  submitData(){
    this.callback({
      companyNameA:this.companyNameA(),
      companyNameB:this.companyNameB(),
      yj:this.yj(),
      zff:this.zff(),
    });
  }
}
